import { render, staticRenderFns } from "./UpdateSysMemberCoupon.vue?vue&type=template&id=0f02b480&scoped=true&"
import script from "./UpdateSysMemberCoupon.vue?vue&type=script&lang=js&"
export * from "./UpdateSysMemberCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f02b480",
  null
  
)

export default component.exports